import { Theme, useMediaQuery } from "@mui/material"
import { ReactNode } from "react"
import { Settings } from "src/@core/context/settingsContext"
import { useSettings } from "src/@core/hooks/useSettings"
import Layout from "src/@core/layouts/Layout"
import HeaderContentNuevo from "./components/HeaderContentNuevo"

interface Props {
    children: ReactNode
    contentHeightFixed?: boolean
    codSistema: number
    codSistemaPrincipal: number
    codSistemaTipo: number
    acciones: {
        saveHandler?: () => void
        sendHandler?: () => void
        closeHandler?: () => void
    }
}

export const NuevaOperacionLayout = ({ children, contentHeightFixed, acciones, codSistema, codSistemaPrincipal, codSistemaTipo }: Props) => {
    // ** Hooks
    const { settings, saveSettings } = useSettings()

    const operacionLayoutSettings: Settings = {
        ...settings,
        layout: 'vertical',
        appBar: 'fixed' //'fixed' TODO: header a appbar
    }

    const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

    return (
        <Layout
            hidden={true}
            settings={operacionLayoutSettings}
            saveSettings={saveSettings}
            contentHeightFixed={contentHeightFixed}
            verticalLayoutProps={{
                navMenu: {},
                appBar: {
                    content: props => (
                        <HeaderContentNuevo
                            isSmallScreen={isSmallScreen}
                            settings={operacionLayoutSettings}
                            toggleNavVisibility={props.toggleNavVisibility}
                            acciones={acciones}
                            codSistema={codSistema}
                            codSistemaPrincipal={codSistemaPrincipal}
                            codSistemaTipo={codSistemaTipo}
                        />
                    )
                }
            }}
        >
            {children}
        </Layout>
    )
}
